"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPerformanceScpiFonctionTrads = void 0;
exports.ESubPerformanceScpiFonctionTrads = {
    desDeux: "Des deux",
    dividendeDistribue: "Du dividende distribué",
    evolutionPrixPart: "De l'évolution du prix de la part",
};
